"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_helmet_1 = require("react-helmet");
const react_router_dom_1 = require("react-router-dom");
const react_intl_1 = require("react-intl");
const react_router_1 = require("react-router");
const antd_1 = require("antd");
const elements_1 = require("@src/components/elements");
const config_1 = __importDefault(require("@src/config"));
const MissingContentView_1 = __importDefault(require("@src/components/modules/MissingContentView/MissingContentView"));
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const loading_wrapper_1 = __importDefault(require("@src/components/modules/global/loading-wrapper"));
const excerpt_1 = __importDefault(require("../excerpt"));
const Homepage = () => {
    // @ts-ignore
    const { page } = (0, react_router_1.useParams)();
    const history = (0, react_router_dom_1.useHistory)();
    const location = (0, react_router_dom_1.useLocation)();
    const intl = (0, react_intl_1.useIntl)();
    const currentPage = page !== undefined ? parseInt(page, 10) : 1;
    const { data: posts, refetch, isLoading, } = (0, useSSRFetch_1.useSSRFetch)(useSSRFetch_1.SSRFetchConfig.magazinePosts.key, currentPage, [location.pathname, currentPage]);
    const { data: postsCount } = (0, useSSRFetch_1.useSSRFetch)(useSSRFetch_1.SSRFetchConfig.magazinePostsCount.key, undefined, [
        location.pathname,
    ]);
    (0, react_1.useEffect)(() => {
        refetch();
    }, [location.pathname]);
    const onChangePage = newPage => {
        if (newPage === 1) {
            return history.pushLocalized('/magazin');
        }
        return history.pushLocalized(`/magazin/archiv/${newPage}`);
    };
    if (Array.isArray(posts) && !posts.length) {
        return ((0, jsx_runtime_1.jsx)(MissingContentView_1.default, { heading: intl.formatMessage({
                id: 'magazine.missing_content_heading',
                defaultMessage: 'Žiadne ponuky"',
            }), message: intl.formatMessage({
                id: 'magazine.missing_content_message',
                defaultMessage: 'Bohužiaľ, momentálne nie sú k dispozícii žiadne ponuky',
            }) }));
    }
    return ((0, jsx_runtime_1.jsx)(elements_1.Holder, { marginVertical: true, children: (0, jsx_runtime_1.jsx)(loading_wrapper_1.default, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "center", children: (0, jsx_runtime_1.jsxs)(antd_1.Col, { children: [posts &&
                            posts.map(post => {
                                return (0, jsx_runtime_1.jsx)(excerpt_1.default, { post: post }, post.title);
                            }), posts && postsCount && postsCount > config_1.default.magazine.postsPerPage && ((0, jsx_runtime_1.jsx)(elements_1.Pagination, { current: currentPage, total: postsCount, defaultPageSize: config_1.default.magazine.postsPerPage, onChange: onChangePage, showSizeChanger: false })), currentPage > 1 && ((0, jsx_runtime_1.jsx)(react_helmet_1.Helmet, { children: (0, jsx_runtime_1.jsx)("meta", { name: "robots", content: "noindex, follow" }) }))] }) }) }) }));
};
exports.default = Homepage;
